import { render, staticRenderFns } from "./FileBrowserFile.vue?vue&type=template&id=2a56c587&scoped=true&lang=html"
import script from "./FileBrowserFile.vue?vue&type=script&lang=js"
export * from "./FileBrowserFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a56c587",
  null
  
)

export default component.exports